import * as React from 'react';
import { Button } from '@/components/ui/Button';
import clsx from 'clsx';

interface WebScraperCardProps {
  onStart: () => void;
  isLoading?: boolean;
  variant?: 'free' | 'premium';
  isActivated?: boolean;
}

/** Card toggling free or premium internet data collection for training. */
export const WebScraperCard: React.FC<WebScraperCardProps> = ({
  onStart,
  isLoading = false,
  variant = 'free',
  isActivated = false,
}) => {
  const isPremium = variant === 'premium';

  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center p-6 text-center',
        'h-[198px] w-full xl:w-[340px]',
        'rounded-20',
        !isPremium && 'bg-credits-gradient'
      )}
      style={
        isPremium
          ? {
              background:
                'linear-gradient(179.97deg, #CF9E50 0.03%, #D5AA4E 38.94%, #F3E767 80.97%)',
            }
          : undefined
      }
    >
      <h3 className='mb-1 font-sans text-20 font-medium text-white'>
        {isPremium ? (
          <>
            EchoPro <br /> Collect Info From the Internet
          </>
        ) : (
          <>Collect Info From the Internet</>
        )}
      </h3>

      <p className='mb-6 font-sans text-14 font-normal text-white/70'>
        {isPremium ? (
          <>
            will cost only 55 credits,
            <br />
            but will improve your echo substantially
          </>
        ) : (
          <>
            Free search,
            <br />
            but will improve your echo
          </>
        )}
      </p>

      <Button
        onClick={onStart}
        disabled={isLoading || isActivated}
        className={clsx(
          'h-[40px] w-full rounded-30 font-bold uppercase',
          isActivated
            ? 'cursor-default bg-white/80 text-brand-800'
            : isLoading
              ? 'cursor-not-allowed bg-gray-400 text-white'
              : 'bg-white text-brand-800 hover:bg-gray-50'
        )}
      >
        {isActivated ? 'Activated' : isLoading ? 'Processing...' : 'Start'}
      </Button>
    </div>
  );
};
